<template>
  <div>
    <div class="container">
      <p class="MsoNormal" style="text-align: center; font-size: 16px;" align="center">非道路移动柴油机械排气烟度检验报告</p>
      <table style="border-collapse: collapse; width: 100.039%; height: 803.853px; border-color: #000000; border-style: solid; margin-left: auto; margin-right: auto;" border="1">
        <tbody>
          <tr style="height: 22.3958px;">
            <td style="width: 280.734%; height: 22.3958px; text-align: left;" colspan="9">
              <span>报告编号：</span><span style="padding-right: 300px">{{ data.report_id }}</span>
              <span>计量认证号：</span><span>{{ data.metrological_cert_num }}</span>
            </td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 280.734%; height: 22.3958px; text-align: left;" colspan="9">一、所有人或代理人信息</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">姓名<span lang="en-us" xml:lang="en-us">/</span>单位</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.machine_owner }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">联系电话</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.machine_owner_contact }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">联系地址</td>
            <td style="width: 259.837%; height: 22.3958px;" colspan="7">{{ data.machine_owner_province + data.machine_owner_city + data.machine_owner_address }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 280.734%; height: 22.3958px; text-align: left;" colspan="9">二、非道路移动柴油机械基本信息</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">机械类型</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.product_status }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">机械型号</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.model_specification }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">出厂年份</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.manufacture_date ? data.manufacture_date : '/' }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">机械VIN</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.machine_vin_serial }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">生产厂名称</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.manufacturer }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">排放阶段</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.emission_stage }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">发动机制造厂名称</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.engine_manufacturer_name }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">发动机型号</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.engine_model }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">发动机额定净功率<span lang="en-us" xml:lang="en-us">(kW)</span></td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.engine_rated_net_power }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">发动机额定转速<span lang="en-us" xml:lang="en-us">(r/min)</span></td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.engine_rated_speed }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 20.8974%;" colspan="2">发动机后处理器类型</td>
            <td style="height: 22.3958px; width: 23.4765%;" colspan="2">{{ data.engine_aftertreatment_type }}</td>
            <td style="height: 22.3958px; width: 29.4931%;" colspan="2">环保登记号码</td>
            <td style="height: 22.3958px; width: 206.867%;" colspan="3">{{ data.env_reg_num }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 280.734%; text-align: left;" colspan="9">三、检测设备信息</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 20.8974%;" colspan="2">设备名称</td>
            <td style="height: 22.3958px; width: 23.4765%;" colspan="2">{{ data.testing_equipment_name }}</td>
            <td style="height: 22.3958px; width: 29.4931%;" colspan="2">设备型号</td>
            <td style="height: 22.3958px; width: 206.867%;" colspan="3">{{ data.testing_equipment_model_specification }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">设备生产厂家</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.testing_equipment_factory }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">检定<span lang="en-us" xml:lang="en-us">/</span>校准有效期至</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.testing_equipment_calibration_expiry_date }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 280.734%; text-align: left;" colspan="9">四、检测现场环境参数</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 280.734%; text-align: left;" colspan="9">
              <span style="padding-right: 100px;">温度（℃）：{{ data.temperature }}</span>
              <span style="padding-right: 100px;">湿度（%）：{{ data.relative_humidity }}</span>
              <span>大气压力（kPa）： {{ data.atmospheric_pressure }}</span>
            </td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 280.734%; height: 22.3958px; text-align: left;" colspan="9">五、烟度检验记录</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">检测时间</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.test_time }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">检测地点</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.test_location }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">检测开始时间</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.test_start_time }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">检测结束时间</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.test_end_time }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">所属区域</td>
            <td style="width: 23.4765%; height: 22.3958px;" colspan="2">{{ data.region }}</td>
            <td style="width: 29.4931%; height: 22.3958px;" colspan="2">排气烟度限值（执行类别）</td>
            <td style="width: 206.867%; height: 22.3958px;" colspan="3">{{ data.exhaust_smoke_limit }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">检测及判定依据</td>
            <td style="width: 259.837%; height: 22.3958px; text-align: left;" colspan="7">《非道路移动柴油机械排气烟度限值及测量方法》<span lang="en-us" xml:lang="en-us">GB 36886-2018</span></td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">检测方法</td>
            <td style="width: 259.837%; height: 22.3958px;" colspan="7">{{ data.test_method }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 20.8974%; height: 22.3958px;" colspan="2">检测项目</td>
            <td style="width: 38.341%; height: 22.3958px;" colspan="3">实测数值（<span lang="en-us" xml:lang="en-us">m<sup>-1</sup></span>）</td>
            <td style="width: 14.6286%; height: 22.3958px;">平均值（<span lang="en-us" xml:lang="en-us">m<sup>-1</sup></span>）</td>
            <td style="height: 22.3958px; width: 16.5161%;">标准限值（<span lang="en-us" xml:lang="en-us">m<sup>-1</sup></span>）</td>
            <td style="width: 190.351%; height: 22.3958px;" colspan="2">检测结论</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 44.7916px; width: 20.8974%;" colspan="2" rowspan="2">
              <p align="center">光吸收系数<span lang="en-us" xml:lang="en-us">K</span></p>
              （<span lang="en-us" xml:lang="en-us">m<sup>-1</sup></span>）</td>
            <td style="width: 11.5613%; height: 22.3958px;">1</td>
            <td style="width: 11.9152%; height: 22.3958px;">2</td>
            <td style="width: 14.8645%; height: 22.3958px;">3</td>
            <td style="height: 44.7916px; width: 14.6286%;" rowspan="2">{{ data.average_value }}</td>
            <td style="height: 44.7916px; width: 16.5161%;" rowspan="2">{{ data.standard_limit_value }}</td>
            <td style="width: 190.351%; height: 44.7916px;font-weight: bold;" colspan="2" rowspan="2">{{ data.inspection_result }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="width: 11.5613%; height: 22.3958px;">{{ data.light_absorption_coefficient_1 }}</td>
            <td style="width: 11.9152%; height: 22.3958px;">{{ data.light_absorption_coefficient_2 }}</td>
            <td style="width: 14.8645%; height: 22.3958px;">{{ data.light_absorption_coefficient_3 }}</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 280.734%;" colspan="9">六、检测单位信息</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 20.8974%;" colspan="2">单位名称</td>
            <td style="height: 22.3958px; width: 38.341%; text-align: center;" colspan="3">安徽申环检测认证有限公司</td>
            <td style="width: 14.6286%; height: 22.3958px;"><span style="text-align: center;">联系电话</span></td>
            <td style="height: 22.3958px; width: 206.867%; text-align: center;" colspan="3"><span lang="en-us" xml:lang="en-us">0551-62857172<br></span></td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; width: 20.8974%;" colspan="2">联系地址</td>
            <td style="height: 22.3958px; width: 259.837%; text-align: left;" colspan="7">安徽省合肥市经济技术开发区芙蓉路与轿顶路交口东北天润大厦<span lang="en-us" xml:lang="en-us">1703</span>室</td>
          </tr>
          <tr style="height: 22.3958px; text-align: center;">
            <td style="height: 22.3958px; text-align: left; width: 280.734%;" colspan="9">
              <div style="float: left; height: 45px; line-height: 45px;">检验：</div>
              <div style="float: left; margin-top: 5px; width: 100px;"><img v-if="data.inspector_sign" :src="baseURL + data.inspector_sign" style="width: 100px;" alt=""></div>
              <div style="float: left; height: 45px; line-height: 45px;">审核：</div>
              <div style="float: left; margin-top: 5px; width: 100px;"><img v-if="data.reviewer_sign" :src="baseURL + data.reviewer_sign" style="width: 100px;" alt=""></div>
              <div style="float: left; height: 45px; line-height: 45px;">批准：</div>
              <div style="float: left; margin-top: 5px; width: 100px;"><img v-if="data.approver_sign" :src="baseURL + data.approver_sign" style="width: 100px;" alt=""></div>
              <div style="float: left; height: 45px; line-height: 45px;">批准日期：{{ data.approval_date }}</div>
            </td>
          </tr>
          <tr style="height: 87.1875px; text-align: center;">
            <td style="width: 6.48848%; height: 87.1875px;">
              <span>现场</span><br>
              <span>检测</span><br>
              <span>照片</span>
            </td>
            <td style="height: 87.1875px; width: 274.246%;" colspan="8">
              <!--     vehicle_photo展示       -->
              <el-image
                v-for="(item, index) in data.vehicle_photo"
                :key="index"
                :src="item"
                style="margin-right: 10px; height: 80px; float: left"
                fit="contain"
                :preview-src-list="data.vehicle_photo"
              />
            </td>
          </tr>
          <tr style="height: 67.1875px; text-align: center;">
            <td style="height: 67.1875px; width: 280.734%; text-align: left;" colspan="9">说明：<span lang="en-us" xml:lang="en-us">1</span>、本报告须同时具有检测专用章、<span lang="en-us" xml:lang="en-us">CMA</span>章及检测<span lang="en-us" xml:lang="en-us">/</span>审核<span lang="en-us" xml:lang="en-us">/</span>批准人员签字，缺少其中之一则报告无效；<span lang="en-us" xml:lang="en-us">2</span>、本报告未经本机构批准，不得复制（全文复制除外）；<span lang="en-us" xml:lang="en-us">3</span>、本报告检测数据仅对被检品检测时结果负责；<span lang="en-us" xml:lang="en-us">4</span>、受检单位对检测结论如有异议，请于收到报告之日起十五天内，以书面形式向检验机构提出，逾期不予受理。</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 审核记录   -->
    <el-row>
      <el-col :span="24">
        <el-table :data="data.approved_memo" style="width: 100%">
          <el-table-column label="角色">
            <template slot-scope="scope">
              <span v-if="scope.row.role === 1">检测员</span>
              <span v-if="scope.row.role === 2">审核员</span>
              <span v-if="scope.row.role === 3">批准员</span>
            </template>
          </el-table-column>
          <el-table-column label="审核结果" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.result === 1">通过</span>
              <span v-if="scope.row.result === 2">不通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="审核时间" />
          <el-table-column prop="user_sign" label="签名" width="100">
            <template slot-scope="scope">
              <img :src="baseURL + scope.row.user_sign" alt="" style="width: 100px;">
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div style="height: 50px;" />
    <el-form ref="form" :model="offRoadForm" :rules="rules" label-width="100px">
      <!--  通过、不通过     -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="审核结果" prop="result">
            <el-radio-group v-model="offRoadForm.result">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="签名">
            <div v-if="!resultImg">
              <vue-esign ref="esign" :width="800" :height="300" :is-crop="isCrop" :line-width="lineWidth" :line-color="lineColor" :bg-color.sync="bgColor" style="border: 1px solid #CCCCCC" />
              <button class="sign-btn" @click="handleReset">清空画板</button>
              <button class="sign-btn" @click="handleGenerate">确认签名</button>
            </div>
            <!--  展示签名图片        -->
            <img v-if="resultImg" :src="resultImg" alt="" style="width: 30%; height: 30%; margin-top: 10px;">
            <!--  重新签名        -->
            <el-button v-if="resultImg" @click="handleResetSign">重新签名</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 打印按钮  -->
    <div style="text-align: center;">
      <!--      <el-button type="default" @click="print">打印</el-button>-->
      <el-button type="primary" @click="submit">确认审核</el-button>
    </div>
  </div>
</template>

<script>
import vueEsign from 'vue-esign'
import { detailOffRoad, checkOffRoad } from '@/api/verification'
import { uploadBase64 } from '@/api/common'
export default {
  name: 'PreviewOnRoad',
  components: {
    vueEsign
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      id: 0,
      dialogVisible: false,
      data: {
        report_id: '',
        metrological_cert_num: '',
        machine_owner: '',
        machine_owner_contact: '',
        machine_owner_address: '',
        product_status: '',
        model_specification: '',
        manufacture_date: '',
        machine_vin_serial: '',
        manufacturer: '',
        emission_stage: '',
        engine_manufacturer_name: '',
        engine_model: '',
        engine_rated_net_power: '',
        engine_rated_speed: '',
        engine_aftertreatment_type: '',
        env_reg_num: '',
        testing_equipment_name: '',
        testing_equipment_model_specification: '',
        testing_equipment_factory: '',
        testing_equipment_calibration_expiry_date: '',
        temperature: '',
        relative_humidity: '',
        atmospheric_pressure: '',
        test_time: '',
        test_location: '',
        test_start_time: '',
        test_end_time: '',
        region: '',
        exhaust_smoke_limit: '',
        light_absorption_coefficient_1: '',
        light_absorption_coefficient_2: '',
        light_absorption_coefficient_3: '',
        average_value: '',
        standard_limit_value: '',
        inspection_result: '',
        approval_date: '',
        vehicle_photo: [],
        inspector_sign: '',
        reviewer_sign: '',
        approver_sign: ''
      },
      offRoadForm: {
        result: '',
        user_sign: ''
      },
      rules: {
        result: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ]
      },
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      baseURL: process.env.VUE_APP_BASE_URL
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.id = val.id
          this.fetchData(val.id)
        }
      },
      deep: true
    }
  },
  created() {
    const id = this.item.id
    this.id = id
    this.fetchData(id)
    if (this.$refs.form) {
      this.$refs.form.resetFields()
    }
  },
  methods: {
    fetchData(id) {
      detailOffRoad(id).then(response => {
        this.data = response.data
        this.data.manufacture_date = this.formatDay(this.data.manufacture_date)
        this.data.testing_equipment_calibration_expiry_date = this.formatDate(this.data.testing_equipment_calibration_expiry_date)
        this.data.test_time = this.formatDate(this.data.test_time)
        this.data.test_start_time = this.formatDateTime(this.data.test_start_time)
        this.data.test_end_time = this.formatDateTime(this.data.test_end_time)
        // 空值处理为 ‘/’
        for (const key in this.data) {
          if (this.data[key] === null) {
            this.data[key] = '/'
          }
        }
        this.data.vehicle_photo = response.data.vehicle_photo.map(item => process.env.VUE_APP_BASE_URL + item)
        console.log(this.data)
      })
    },
    // 打印 class=container 的内容
    print() {
      const content = document.querySelector('.container').innerHTML
      const printWindow = window.open('', '_blank')
      printWindow.document.open()
      printWindow.document.write(`
        <html>
          <head>
            <title>打印</title>
            <style>
              body {
                font-size: 12px;
                font-family: simsun, serif;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 20px;
              }
              tr td {
                padding: 0;
              }
              .el-image__preview {
                height: 80px;
              }
            </style>
          </head>
          <body>
            ${content}
          </body>
        </html>
      `)
      printWindow.document.close()
      printWindow.print()
    },
    formatDate(dateString) {
      // 将日期字符串分割为年、月、日
      const parts = dateString.split('-')
      const year = parts[0]
      const month = parts[1]
      const day = parts[2]

      // 转换月和日的格式，确保它们是两位数
      const formattedMonth = month.length === 1 ? `0${month}` : month
      const formattedDay = day.length === 1 ? `0${day}` : day

      // 返回格式化后的日期字符串
      return `${year}年${formattedMonth}月${formattedDay}日`
    },
    // 将日期字符串转换为 年月的格式
    formatDay(dateString) {
      // 将日期字符串分割为年、月、日
      const parts = dateString.split('-')
      const year = parts[0]
      const month = parts[1]

      // 转换月和日的格式，确保它们是两位数
      const formattedMonth = month.length === 1 ? `0${month}` : month

      // 返回格式化后的日期字符串
      return `${year}年${formattedMonth}月`
    },
    // 将日期字符串转换为 年月日 时分秒的格式
    formatDateTime(dateString) {
      // 将日期字符串分割为年、月、日
      const parts = dateString.split(' ')
      const date = parts[0]
      const time = parts[1]

      // 将日期字符串分割为年、月、日
      const dateParts = date.split('-')
      const year = dateParts[0]
      const month = dateParts[1]
      const day = dateParts[2]
      // 将日分秒字符串分割为时、分、秒
      const timeParts = time.split(':')
      const hour = timeParts[0]
      const minute = timeParts[1]
      // const second = timeParts[2]

      // 转换月和日的格式，确保它们是两位数
      const formattedMonth = month.length === 1 ? `0${month}` : month
      const formattedDay = day.length === 1 ? `0${day}` : day
      const formattedHour = hour.length === 1 ? `0${hour}` : hour
      const formattedMinute = minute.length === 1 ? `0${minute}` : minute

      // 返回格式化后的日期字符串
      return `${year}年${formattedMonth}月${formattedDay}日 ${formattedHour}时${formattedMinute}分`
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.resultImg = res
        uploadBase64({
          file: res
        }).then(response => {
          this.offRoadForm.user_sign = response.data.path
        })
      }).catch(err => {
        alert(err) // 画布没有签字时会执行这里 'Not Signned'
      })
    },
    handleResetSign() {
      this.resultImg = ''
      this.$refs.esign.reset()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 签名
          if (!this.offRoadForm.user_sign) {
            this.$message.error('请签名')
            return
          }
          this.offRoadForm.id = this.id
          checkOffRoad(this.offRoadForm).then(response => {
            this.$message({
              message: '审核成功',
              type: 'success'
            })
            this.$emit('success:check')
          })
        }
      })
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
tr td {
  padding: 0;
}
</style>
